export const TOURNAMENT_SYSTEM_TOOLTIP = (
  <div style={{ whiteSpace: "pre-line", lineHeight: "1.5" }}>
    The choice of the correct Tournament system plays a vital role in the organisation of the
    competition. Make sure you are aware about the difference between the systems - you can learn
    more in our dedicated knowledgebase (
    <a
      href="https://passport.gg/vocabulary"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      https://passport.gg/vocabulary
    </a>
    ).{"\n\n"}
    If you choose Round-robin formats, bear in mind that you will need to set up additional
    parameters (e.g. amount of teams per group, number of teams proceeding further etc.). If you
    have questions about the formats, you can:{"\n\n"}
    {"> "}learn more in the educational materials{" "}
    <a
      href="https://bit.ly/3DSzzJ6"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      https://bit.ly/3DSzzJ6
    </a>
    {"\n"}
    {"> "}contact our support -{" "}
    <a
      href="mailto:support@passport.gg"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      support@passport.gg
    </a>
    . Bear in mind, that for free tiers the response time may be over 3 business days.
  </div>
);

export const MATCHES_FORMAT_TOOLTIP = (
  <div style={{ whiteSpace: "pre-line", lineHeight: "1.5" }}>
    Match format (BO stands for Best Of - literally meaning how many matches can be played to define
    the winner) - is an important parameter that influences the competitive spirit. Bear in mind
    that in BO1 the factor of chance and luck can influence a lot. At the same time, BO5 and above
    can make the competition really long.{"\n\n"}
    If you have questions about that, you can:{"\n\n"}
    {"> "}learn more in the educational materials{" "}
    <a
      href="https://bit.ly/3DSzzJ6"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      https://bit.ly/3DSzzJ6
    </a>
    {"\n"}
    {"> "}contact our support -{" "}
    <a
      href="mailto:support@passport.gg"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      support@passport.gg
    </a>
    . Bear in mind, that for free tiers the response time may be over 3 business days.
  </div>
);

export const PARTICIPANT_TYPE_TOOLTIP = (
  <div style={{ whiteSpace: "pre-line", lineHeight: "1.5" }}>
    Please choose the amount of participants. Bear in mind that most sports simulators are played
    1v1 (there are some exceptions though), while many popular team titles are played in 5v5 format
    (but some experiment formats exist there as well; as well as some titles, like Rocket League are
    played in other formats).{"\n\n"}
    This selection will influence the amount of people able to access the match-ticket, hence check
    your plans before selecting the format.{"\n\n"}
    If you have questions about that, you can:{"\n\n"}
    {"> "}learn more in the educational materials{" "}
    <a
      href="https://bit.ly/3DSzzJ6"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      https://bit.ly/3DSzzJ6
    </a>
    {"\n"}
    {"> "}contact our support -{" "}
    <a
      href="mailto:support@passport.gg"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      support@passport.gg
    </a>
    . Bear in mind, that for free tiers the response time may be over 3 business days.
  </div>
);

export const MAXIMUM_PARTICIPANTS_TOOLTIP = (
  <div style={{ whiteSpace: "pre-line", lineHeight: "1.5" }}>
    Please choose the maximal amount of participants (amount of players for 1v1 or teams for other
    formats).{"\n\n"}
    If you plan to have a big number of participants, but not sure yet the exact number - better
    choose more, then less. The system will adapt to a smaller number of players if needed. However,
    if the selection is limited and you need to ensure that only a limited number of participants
    can join - put the exact limit.{"\n\n"}
    If you have questions about that, you can:{"\n\n"}
    {"> "}learn more in the educational materials{" "}
    <a
      href="https://bit.ly/3DSzzJ6"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      https://bit.ly/3DSzzJ6
    </a>
    {"\n"}
    {"> "}contact our support -{" "}
    <a
      href="mailto:support@passport.gg"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      support@passport.gg
    </a>
    . Bear in mind, that for free tiers the response time may be over 3 business days.
  </div>
);

export const PARTICIPANTS_IN_GROUP_TOOLTIP = (
  <div style={{ whiteSpace: "pre-line", lineHeight: "1.5" }}>
    This is the parameter that is actually only for Round-robin format. If you want to select
    another format, please check the selection above.{"\n\n"}
    If you are planning to have a group stages format, you can use this parameter to set up the
    maximal number of players per group.{"\n\n"}
    If you plan to have a limited number of players, but want to have more groups - set this
    parameter to a lower number (but not advised to have less than 4).{"\n\n"}
    If you have questions about that, you can:{"\n\n"}
    {"> "}learn more in the educational materials{" "}
    <a
      href="https://bit.ly/3DSzzJ6"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      https://bit.ly/3DSzzJ6
    </a>
    {"\n"}
    {"> "}contact our support -{" "}
    <a
      href="mailto:support@passport.gg"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      support@passport.gg
    </a>
    . Bear in mind, that for free tiers the response time may be over 3 business days.
  </div>
);

export const DIRECT_SLOTS_TOOLTIP = (
  <div style={{ whiteSpace: "pre-line", lineHeight: "1.5" }}>
    This is the parameter that is actually only for Round-robin format. If you want to select
    another format, please check the selection above.{"\n\n"}
    This parameter regulates how many participants from each group will proceed to the elimination
    stage directly. Make sure the amount of players proceed do not exceed the amount of slots you
    plan to have in the elimination stage.{"\n\n"}
    If you have questions about that, you can:{"\n\n"}
    {"> "}learn more in the educational materials{" "}
    <a
      href="https://bit.ly/3DSzzJ6"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      https://bit.ly/3DSzzJ6
    </a>
    {"\n"}
    {"> "}contact our support -{" "}
    <a
      href="mailto:support@passport.gg"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      support@passport.gg
    </a>
    . Bear in mind, that for free tiers the response time may be over 3 business days.
  </div>
);

export const SECOND_CHANCE_TOOLTIP = (
  <div style={{ whiteSpace: "pre-line", lineHeight: "1.5" }}>
    This is the parameter that is actually only for Round-robin format. If you want to select
    another format, please check the selection above.{"\n\n"}
    This parameter is needed in the situation, when the participants at certain positions are not
    proceeding directly to the elimination stage, but play decider matches with the participants
    getting similar positions in other groups{"\n\n"}
    It's not an obligatory parameter, hence make sure if you want to have this extra step. Also,
    make sure the amount of players proceed do not exceed the amount of slots you plan to have in
    the elimination stage.{"\n\n"}
    If you have questions about that, you can:{"\n\n"}
    {"> "}learn more in the educational materials{" "}
    <a
      href="https://bit.ly/3DSzzJ6"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      https://bit.ly/3DSzzJ6
    </a>
    {"\n"}
    {"> "}contact our support -{" "}
    <a
      href="mailto:support@passport.gg"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      support@passport.gg
    </a>
    . Bear in mind, that for free tiers the response time may be over 3 business days.
  </div>
);

export const ELIGIBILITY_RULES_TOOLTIP = (
  <div style={{ whiteSpace: "pre-line", lineHeight: "1.5" }}>
    This parameter is helpful if you want to add additional eligibility rules - like age,
    nationality etc.{"\n\n"}
    If selected, the participants will need to provide additional information before registering to
    the event. This will allow you to have automated filtering of the participants based on the core
    parameters.{"\n\n"}
    If you have questions about that, you can:{"\n\n"}
    {"> "}learn more in the educational materials{" "}
    <a
      href="https://bit.ly/3DSzzJ6"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      https://bit.ly/3DSzzJ6
    </a>
    {"\n"}
    {"> "}contact our support -{" "}
    <a
      href="mailto:support@passport.gg"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      support@passport.gg
    </a>
    . Bear in mind, that for free tiers the response time may be over 3 business days.
  </div>
);

export const TOURNAMENT_DATES_TOOLTIP = (
  <div style={{ whiteSpace: "pre-line", lineHeight: "1.5" }}>
    These parameters regulate the timing of the event - from the registration to the final matches.
    You can set up the dates, as well as exact timings. If you have some time-dependent actions
    (e.g. final event in the venue, broadcast etc) it's advised to set up the time with high
    approximation. For small grassroots events without precise timings it's advised to set up the
    time of start as early as possible, while the end - as late as possible.{"\n\n"}
    Make sure, you're keeping the other timings (e.g. registrations, matches etc) within this
    timeframe.{"\n\n"}
    If you have questions about that, you can:{"\n\n"}
    {"> "}learn more in the educational materials{" "}
    <a
      href="https://bit.ly/3DSzzJ6"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      https://bit.ly/3DSzzJ6
    </a>
    {"\n"}
    {"> "}contact our support -{" "}
    <a
      href="mailto:support@passport.gg"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      support@passport.gg
    </a>
    . Bear in mind, that for free tiers the response time may be over 3 business days.
  </div>
);

export const REGISTRATION_DATES_TOOLTIP = (
  <div style={{ whiteSpace: "pre-line", lineHeight: "1.5" }}>
    This is the parameter, setting up the registration timeframe. You can have a long pre-event
    time, or have a short time needed to get the people who are ready into the system. It's advised
    to have time for the registration that will allow you to plan the promotion, allowing to inform
    as many people as possible to learn about the event and to register for it.{"\n\n"}
    If you have questions about that, you can:{"\n\n"}
    {"> "}learn more in the educational materials{" "}
    <a
      href="https://bit.ly/3DSzzJ6"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      https://bit.ly/3DSzzJ6
    </a>
    {"\n"}
    {"> "}contact our support -{" "}
    <a
      href="mailto:support@passport.gg"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      support@passport.gg
    </a>
    . Bear in mind, that for free tiers the response time may be over 3 business days.
  </div>
);

export const MATCH_SCHEDULE_TOOLTIP = (
  <div style={{ whiteSpace: "pre-line", lineHeight: "1.5" }}>
    This is the parameter that regulates the time and date of the start of the competitions. This
    will allow you to plan the competition and ensure that participants are aware when they need to
    come to the venue or join online.{"\n\n"}
    <strong>Interval between rounds (minutes)</strong> - This is a parameter that helps to set up
    the timing between the rounds. Depending on the game title, number of participants and
    infrastructure (e.g. referees). You may need to plan technical pauses etc.
    {"\n\n"}
    If you have questions about that, you can:{"\n\n"}
    {"> "}learn more in the educational materials{" "}
    <a
      href="https://bit.ly/3DSzzJ6"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      https://bit.ly/3DSzzJ6
    </a>
    {"\n"}
    {"> "}contact our support -{" "}
    <a
      href="mailto:support@passport.gg"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      support@passport.gg
    </a>
    . Bear in mind, that for free tiers the response time may be over 3 business days.
  </div>
);

export const REQUIRED_CHECK_IN_TOOLTIP = (
  <div style={{ whiteSpace: "pre-line", lineHeight: "1.5" }}>
    Within the Passport.GG esports ecosystem you can define the strictness in regards to timing and
    procedures. If you are doing semi-pro and pro events, you may expect the players to be ready to
    follow strict timings and regulations. Our system allows you to automate the process for such
    events, considerably decreasing the burden on referees and admins.{"\n\n"}
    For grassroots events such regulations can create issues - as the system will ensure that the
    process is run within the strict timings.{"\n\n"}
    If you have questions about that, you can:{"\n\n"}
    {"> "}learn more in the educational materials{" "}
    <a
      href="https://bit.ly/3DSzzJ6"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      https://bit.ly/3DSzzJ6
    </a>
    {"\n"}
    {"> "}contact our support -{" "}
    <a
      href="mailto:support@passport.gg"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      support@passport.gg
    </a>
    . Bear in mind, that for free tiers the response time may be over 3 business days.
  </div>
);

export const AUTOCOMPLETE_MATCH_TICKER_TOOLTIP = (
  <div style={{ whiteSpace: "pre-line", lineHeight: "1.5" }}>
    This parameter allows to automate running matches, making the process smooth and following the
    strict timings. Leveraging this feature you can run events with a big number of participants
    with a small number of admins.{"\n\n"}
    Bear in mind that strict regulations may create frustrations for the events with grassroot
    participants.{"\n\n"}
    If you have questions about that, you can:{"\n\n"}
    {"> "}learn more in the educational materials{" "}
    <a
      href="https://bit.ly/3DSzzJ6"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      https://bit.ly/3DSzzJ6
    </a>
    {"\n"}
    {"> "}contact our support -{" "}
    <a
      href="mailto:support@passport.gg"
      style={{ color: "#90caf9", textDecoration: "underline" }}
      onClick={e => e.stopPropagation()}
    >
      support@passport.gg
    </a>
    . Bear in mind, that for free tiers the response time may be over 3 business days.
  </div>
);
